import { useEffect } from "react";

export const useParentGoBackMessage = (canGoBack: boolean) => {
	useEffect(() => {
		if (typeof window !== "undefined" && window.parent) {
			const payload = { can_go_back: canGoBack };
			window.parent.postMessage(payload, "*");
		}
	}, [canGoBack]);
};
